import React from 'react';
import { SearchBar } from '@metarouter-private/mr-mui';
import { useTransformationLibTableContext } from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibTableContext';
import { FILTER_KEYS } from 'app/clusters/TransformationLibTab/TransformationLibTable/TransformationLibTableContext/filters';

function TransformationLibNameFilter() {
  const { filters, handleFilterChange } = useTransformationLibTableContext();

  // currently *not* debouncing since filtering is client side
  // but heads-up if you debounce, then may have to introduce local state:
  // - to keep as a controlled component as the change handler will be delayed
  // - handle the case of clearing filters when the cluster changes
  const handleChange = event => {
    if (!event || !event.target) {
      return;
    }

    handleFilterChange({
      [FILTER_KEYS.NAME]: event.target.value ?? '',
    });
  };

  return (
    <SearchBar
      name="moduleName"
      aria-label="Filter by name"
      placeholder="Filter by Name..."
      size="small"
      value={filters[FILTER_KEYS.NAME]}
      onChange={handleChange}
    />
  );
}

export default TransformationLibNameFilter;
